import type { SurveyTypes } from '#shared/types/Survey'

// Below this we hide the count - "Vyplnili 3" is worse social proof than none.
const MIN_PUBLIC_COUNT = 25

/**
 * Real completed-submission counts per test from /api/sebapoznanie/test-stats.
 * Shared key so the listing and every test landing page reuse one request.
 *
 * No `default` on purpose: landing pages render client-only during hydration, and Nuxt skips
 * the fetch there whenever data is already defined - a default would mean the request never runs.
 */
export function useSebapoznanieTestStats() {
    const request = useFetch('/api/sebapoznanie/test-stats', {
        key: 'sebapoznanie-test-stats'
    })

    /** Count to show publicly, or 0 when it is too small to be worth showing. */
    function getPublicCount(surveyType: SurveyTypes | string): number {
        const count = request.data.value?.countsBySurveyType?.[surveyType] || 0
        return count >= MIN_PUBLIC_COUNT ? count : 0
    }

    return Object.assign(request, { getPublicCount })
}
